import polyline from '@mapbox/polyline';

export const decodeGeometry = (encoded) => {
  const coordinates = polyline.decode(encoded);
  return coordinates.map(([lat, lng]) => [lng, lat]);
};
